import { useHistory } from 'react-router'

import { Assignment } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { Placeholder } from '@collaborate-health/uikit'
import { trainingMaterialTitleFormatter } from '@tabeeb/modules/shared/utils/text'

const NoTrainingMaterialsFoundPlaceholder: React.FC = () => {
  const history = useHistory()

  return (
    <Placeholder
      icon={Assignment}
      title={trainingMaterialTitleFormatter.format('No training materials found...')}
      subtitle={trainingMaterialTitleFormatter.format('Click here to open all training materials page')}
      onClick={() => {
        history.push(Routes.trainingMaterials)
      }}
    />
  )
}

export default NoTrainingMaterialsFoundPlaceholder

